import omit from 'lodash/omit';
import { mapActions } from 'vuex';

const keywordMixin = {
  data() {
    return {
      categories: undefined,
      langs: [
        { id: 'en', name: 'co.uk' },
        { id: 'it', name: 'it' },
        { id: 'es', name: 'es' },
        { id: 'nl', name: 'nl' },
      ],
      classicTranslateButtonLoading: false,
      semrushTranslateButtonLoading: false,
      semrushButtonLoading: false,
      semrushResults: undefined,
      selectedSemrushResult: undefined,
    };
  },
  async mounted() {
    try {
      const response = await this.$http.get('/api/categories/list');
      this.categories = response.data;
    } catch (e) {
      this.snackbar({ color: 'error', text: 'Impossible de charger les catégories' });
    }
  },
  watch: {
    'form.keywordKind': {
      handler() {
        this.form.targetKeyword = undefined;
      },
      immediate: true,
    }
  },
  computed: {
    ready() {
      return this.categories !== undefined
    },
    classicTranslateButtonDisabled() {
      return this.form.frenchKeyword.trim() === '' || this.form.lang == undefined;
    },
    semrushButtonDisabled() {
      return this.form.frenchKeyword.trim() === '' || this.form.lang == undefined;
    },
    semrushTranslateButtonDisabled() {
      return this.form.frenchKeyword.trim() === '' || this.selectedSemrushResult == undefined;
    },
  },
  methods: {
    ...mapActions(['snackbar', 'addProject']),
    async classicTranslate() {
      this.classicTranslateButtonLoading = true;
      try {
        const to = this.form.lang;
        const text = this.form.frenchKeyword;
        const response = await this.$http.post('/api/translate', { to, text });
        this.form.targetKeyword = response.data;
        this.classicTranslateButtonLoading = false;
      } catch (e) {
        this.snackbar({ color: 'error', text: 'Impossible de traduire le texte' });
        this.classicTranslateButtonLoading = false;
      }
    },
    async semrushTranslate() {
      this.semrushTranslateButtonLoading = true;
      try {
        const to = this.form.lang;
        const text = this.selectedSemrushResult;
        const response = await this.$http.post('/api/translate', { to, text });
        this.form.targetKeyword = response.data;
        this.semrushTranslateButtonLoading = false;
      } catch (e) {
        this.snackbar({ color: 'error', text: 'Impossible de traduire le texte' });
        this.semrushTranslateButtonLoading = false;
      }
    },
    async semrush() {
      this.semrushButtonLoading = true;
      try {
        const text = this.form.frenchKeyword;
        const response = await this.$http.post('/api/semrush', { text });
        this.semrushResults = response.data;
        this.semrushButtonLoading = false;
        this.selectedSemrushResult = undefined;
      } catch (e) {
        this.snackbar({ color: 'error', text: 'Impossible de faire la recherche semrush' });
        this.semrushButtonLoading = false;
      }
    },
    selectSemrushResult(result) {
      this.selectedSemrushResult = result;
    },
    async submit() {
      if (this.submitDisabled) return;
      const data = omit(this.form, 'keywordKind');
      const response = await this.$http.post('/api/projects/add', data);
      const project = response.data;
      this.addProject(project);
      this.$router.push({ name: 'ProjectDetail', params: { projectId: project.id } });
    }
  }
}

export default keywordMixin;
